import * as ChartControlBarUI from '../ChartControlBarUI';
import { SingleSelectMenu } from '../../../Dropdown';
import { useAppDispatch } from '../../../../redux/hooks';
import { selectPredictionKindAction } from '../../../../redux/slices/analyses';
import { assertCondition } from '../../../../utils/types';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { useChartContext } from '../../ChartContext';

const PredictionControlBar = () => {
  const dispatch = useAppDispatch();
  const {
    metadata: { analysisId },
    chartData,
  } = useChartContext();

  assertCondition(chartData?.queryType === QueryType.Prediction);
  const { correlationKinds, selectedValue } = chartData.data;

  const setSelection = (newValue: string) => {
    dispatch(selectPredictionKindAction({ id: analysisId, kind: newValue }));
  };

  return (
    <ChartControlBarUI.ControlBarRow>
      <SingleSelectMenu
        options={correlationKinds.map((option) => ({
          value: option.key,
          text: option.display,
        }))}
        value={selectedValue}
        onChange={setSelection}
      />
    </ChartControlBarUI.ControlBarRow>
  );
};

export default PredictionControlBar;
